<template>
  <div>
    <!-- MODAL CREAR USUARIO NUEVO -->
    <el-dialog
      title="Agregar una Empresa"
      :visible.sync="showModal"
      width="90%"
      :lock-scroll="false"
      v-on:close=""
      max-width="500px"
    >
      <div class="col-sm-12 entrada">
        <div class="col-sm-3">
          <label>Nombre</label>
        </div>
        <div class="col-sm-9">
          <el-input
            type="text"
            v-validate="'required'"
            required
            name="nombre"
            placeholder="Nombre de la compañia"
            v-model="companyNew.nombre"
          ></el-input>
          <!-- <span>{{ errors.first('nombre') }}</span> -->
        </div>
      </div>
      <div class="col-sm-12 entrada">
        <div class="col-sm-3">
          <label>Razón Social</label>
        </div>
        <div class="col-sm-9">
          <el-input
            type="text"
            v-validate="'required'"
            name="Razon Social"
            required
            placeholder="Razón Social"
            v-model="companyNew.razonSocial"
          ></el-input>
          <!-- <span>{{ errors.first('Razón Social') }}</span> -->
        </div>
      </div>
      <div class="col-sm-12 entrada">
        <div class="col-sm-3">
          <label>CUIT</label>
        </div>
        <div class="col-sm-9">
          <el-input
            type="text"
            required
            placeholder="CUIT"
            v-model="companyNew.cuit"
          ></el-input>
        </div>
      </div>
      <!--
             <div class="col-sm-12 entrada">
                 <div class="col-sm-3">
                     <label>Mail corporativo</label>
                 </div>
                 <div class="col-sm-9">
                     <el-input type="text" required placeholder="Mail corporativo" v-model="companyNew.corporateMail"></el-input>
                 </div>
             </div>
             -->
      <div class="col-sm-12 entrada">
        <div class="col-sm-3">
          <label>Rubros</label>
        </div>
        <div class="col-sm-9">
          <el-select
            v-model="currentIdRubro"
            required
            multiple
            placeholder="Seleccionar Rubro"
          >
            <el-option
              v-for="item in rubros"
              :key="item.idRubro"
              :value="item.idRubro"
              :label="item.nombre"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-sm-12 entrada">
        <div class="col-sm-3">
          <label>Comentarios sobre la Empresa:</label>
        </div>
        <div class="col-sm-9">
          <el-input
            type="textarea"
            maxlength="255"
            show-word-limit
            :rows="5"
            v-model="companyNew.descripcion"
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-primary" v-on:click="saveCompany()">Guardar</button>
        <button class="btn" v-on:click="hideModal()">Cancelar</button>
      </span>
    </el-dialog>
    <!-- MODAL DETALLES -->
    <el-dialog
      title="Detalle"
      :visible.sync="showModalDetails"
      width="90%"
      :lock-scroll="false"
      v-on:close="this.currentIdRubro = []"
      max-width="500px"
    >
      <div class="col-md-12">
        <div style="display:flex; flex-wrap: wrap; gap: 1rem; margin-bottom: 1rem;">
          <el-button style="margin-left:0;" type="primary" @click="viewCompanyData(0, currentCompany.idCompany, currentCompany.codCountry)"
            >Datos generales</el-button
          >
          <el-button style="margin-left:0;" v-if="currentCompany.codCountry ==='AR'" type="primary" @click="viewCompanyData(1, currentCompany.idCompany, currentCompany.codCountry)"
            >Datos bancarios</el-button
          >
          <el-button style="margin-left:0;" v-if="currentCompany.codCountry ==='PE'" type="primary" @click="viewCompanyData(2, currentCompany.idCompany, currentCompany.codCountry)"
            >Datos bancarios</el-button
          >
          <el-button style="margin-left:0;" v-if="currentCompany.codCountry ==='AR'" type="primary" @click="viewCompanyData(2, currentCompany.idCompany, currentCompany.codCountry)"
            >Datos impositivos</el-button
          >
          <el-button style="margin-left:0;" v-if="currentCompany.codCountry ==='PE'" type="primary" @click="viewCompanyData(1, currentCompany.idCompany, currentCompany.codCountry)"
            >Datos impositivos</el-button
          >
        </div>
      </div>
      <div class="col-sm-12 col-xs-12 entrada">
        <div class="col-sm-3 col-xs-3">
          <label>Nombre</label>
        </div>
        <div class="col-sm-9 col-xs-9" v-if="user.roles.every((rol) => rol.rolesId != 20)">
          <el-input
            type="text"
            required
            :placeholder="currentCompany.company"
            v-model="currentCompany.company"
          ></el-input>
        </div>
        <div class="col-sm-9 col-xs-9" v-if="user.roles.find((rol) => rol.rolesId == 20)">
          <el-input
            type="text"
            disabled
            required
            :placeholder="currentCompany.company"
            v-model="currentCompany.company"
          ></el-input>
        </div>
      </div>
      <div class="col-sm-12 col-xs-12 entrada">
        <div class="col-sm-3 col-xs-3">
          <label>Razón Social</label>
        </div>
        <div class="col-sm-9 col-xs-9" v-if="user.roles.every((rol) => rol.rolesId != 20)">
          <el-input
            type="text"
            required
            :placeholder="currentCompany.companyName"
            v-model="currentCompany.companyName"
            min-width="1"
          ></el-input>
        </div>
        <div class="col-sm-9 col-xs-9" v-if="user.roles.find((rol) => rol.rolesId == 20)">
          <el-input
            type="text"
            disabled
            required
            :placeholder="currentCompany.companyName"
            v-model="currentCompany.companyName"
          ></el-input>
        </div>
      </div>
      <div class="col-sm-12 col-xs-12 entrada">
        <div class="col-sm-3 col-xs-3">
          <label>ID FISCAL</label>
        </div>
        <div class="col-sm-9 col-xs-9" v-if="user.roles.every((rol) => rol.rolesId != 20)">
          <el-input
            type="text"
            required
            :placeholder="currentCompany.cuit"
            v-model="currentCompany.cuit"
          ></el-input>
        </div>
        <div class="col-sm-9 col-xs-9" v-if="user.roles.find((rol) => rol.rolesId == 20)">
          <el-input
            type="text"
            disabled
            required
            :placeholder="currentCompany.cuit"
            v-model="currentCompany.cuit"
          ></el-input>
        </div>
      </div>
      <div class="col-sm-12 entrada" v-if="user.roles.every((rol) => rol.rolesId != 20)">
        <div class="col-sm-3 col-xs-3">
          <label>Comentarios sobre la Empresa:</label>
        </div>
        <div class="col-sm-9 col-xs-9">
          <el-input
            type="textarea"
            maxlength="255"
            show-word-limit
            :rows="5"
            v-model="currentCompany.reasonCalification"
          ></el-input>
        </div>
      </div>
      <div class="col-sm-12 entrada" v-if="user.roles.find((rol) => rol.rolesId == 20)">
        <div class="col-sm-3 col-xs-3">
          <label>Comentarios sobre la Empresa:</label>
        </div>
        <div class="col-sm-9 col-xs-9">
          <el-input
            type="textarea"
            disabled
            maxlength="255"
            show-word-limit
            :rows="5"
            v-model="currentCompany.reasonCalification"
          ></el-input>
        </div>
      </div>
      <div class="col-sm-12 entrada">
        <div class="col-sm-3 col-xs-3">
          <label>Información Adicional:</label>
        </div>
        <div class="col-sm-9 col-xs-9" v-if="user.roles.every((rol) => rol.rolesId != 20)">
          <el-input
            type="textarea"
            required
            maxlength="255"
            show-word-limit
            :rows="5"
            :placeholder="currentCompany.comments"
            v-model="currentCompany.comments"
          ></el-input>
        </div>
        <div class="col-sm-9 col-xs-9" v-if="user.roles.find((rol) => rol.rolesId == 20)">
          <el-input
            type="textarea"
            disabled
            maxlength="255"
            show-word-limit
            :rows="5"
            required
            :placeholder="currentCompany.comments"
            v-model="currentCompany.comments"
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-primary" v-on:click="updateCompany()">Guardar</button>
        <button
          class="btn"
          v-on:click="(showModalDetails = false), $parent.getProviders()"
        >
          Cancelar
        </button>
      </span>
    </el-dialog>
    <!-- MODAL COMENTARIO -->
    <div>
      <el-dialog
        title="Agregar  Comentario"
        :visible.sync="showModalComment"
        width="90%"
        :lock-scroll="false"
        v-on:close=""
        max-width="500px"
      >

        <span slot="footer" class="dialog-footer">
          <button
            class="btn btn-primary"
            v-on:click="updateCalification(company, 'true')"
          >
            Guardar
          </button>
          <button class="btn" v-on:click="hideModalComment()">Cancelar</button>
        </span>
      </el-dialog>
    </div>
    <!-- MODAL COMENTARIO -->
    <div>
      <el-dialog
        title="Agregar  Comentario"
        :visible.sync="showModalComment"
        width="90%"
        :lock-scroll="false"
        v-on:close=""
        max-width="500px"
      >
        <div class="row">
          <div>
            <div class="col-sm-3 col-xs-3">
              <label>Calificación</label>
            </div>
            <div class="col-sm-9 col-xs-9">
              <el-rate
                v-model="company.calification"
                style="float: left"
              ></el-rate>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-3 col-xs-3">
            <label>Descripción de La Empresa:</label>
          </div>
          <div class="col-sm-9 col-xs-9">
            <el-input type="textarea" show-word-limit maxlength="256" :rows="5" v-model="company.reasonCalification">{{
              company.reasonCalification
            }}</el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <button
            class="btn btn-primary"
            v-on:click="updateCalification(company, 'true')"
          >
            Guardar
          </button>
          <button class="btn" v-on:click="hideModalComment()">Cancelar</button>
        </span>
      </el-dialog>
    </div>
    <div>
      <!-- MODAL DOCUMENTACION -->
      <section class="content">
        <el-dialog
          :title="'Documentación de ' + company.companyName"
          :visible.sync="showModalDocumentation"
          class="provider__modal-mobile"
          width="40%"
          :lock-scroll="true"
          :before-close="closeDocumentation"
        >
          <el-row class="entrada" v-for="(doc, index) in documents" :key="doc.idDocument + index">
            <el-col :span="4" style="margin-bottom: 10px">
              <span v-if="filteredDocuments[index]">
                <a :href="filteredDocuments[index].url" target="blank">
                  <el-button type="primary" icon="el-icon-document" circle></el-button>
                </a>
              </span>
              <span v-else>
                <el-button type="danger" icon="el-icon-close" circle></el-button>
              </span>
            </el-col>
            <el-col :span="12" style="margin-top: 10px">
              {{ doc.documentName }}
            </el-col>
            <span v-if="previousDocuments[index]">
              <br /><br />
              <el-tree
                :data="previousDocuments[index]"
                @node-click="openNodeUrl"
                style="color: #1f8ef0; margin-left: 50px"
              ></el-tree>
            </span>
          </el-row>
          <span slot="footer" class="dialog-footer">
            <button class="btn btn-primary" @click="saveDocumentation">Guardar</button>
            <button class="btn" @click="closeDocumentation">Cancelar</button>
          </span>
        </el-dialog>
        <!-- MODAL OPERACIONES -->
        <el-dialog
          :title="'Operaciones de ' + company.companyName"
          :visible.sync="showModalOperations"
          width="90%"
          :fullscreen="true"
          :lock-scroll="true"
          v-on:close="showModalOperations = false"
        >
          <div class="box-body" style="max-height: 100%; overflow: auto">
            <div class="">
              <div style="margin-bottom: 10px">
                <el-row>
                  <el-col :span="6" style="text-align: center">
                    <span class="input-label"> Estado </span>
                    <el-select
                      clearable
                      placeholder="Estado"
                      multiple
                      v-model="filtersOperations[2].value"
                    >
                      <el-option
                        v-for="item in statusList"
                        :value="item.statusId"
                        :key="item.statusId"
                        :label="item.description"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="1" style="text-align: center; padding-top: 8px">
                    <span class="input-label"> OC </span>
                  </el-col>
                  <el-col :span="4">
                    <el-input
                      v-model="filtersOperations[0].value"
                      placeholder="OC"
                    ></el-input>
                  </el-col>
                  <el-col :span="10" style="text-align: center">
                    <span class="input-label"> Fecha </span>
                    <el-date-picker
                      v-model="filtersOperations[1].value"
                      type="daterange"
                      range-separator="A"
                      start-placeholder="Desde"
                      end-placeholder="Hasta"
                      unlink-panels
                    >
                    </el-date-picker>
                  </el-col>
                </el-row>
              </div>
              <data-tables
                :data="company.operations"
                :pagination-props="{ pageSizes: [5, 10, 15] }"
                :filters="filtersOperations"
              >
                <el-table-column
                  v-for="title in titlesOperations"
                  :prop="title.prop"
                  :label="title.label"
                  :key="title.prop"
                  sortable="custom"
                >
                </el-table-column>
                <el-table-column label="PDF">
                  <template slot-scope="scope">
                    <a :href="scope.row.pdf" target="_blank" style="padding-right: 20px">
                      <i class="fa fa-file-pdf-o" /> Ver
                    </a>
                  </template>
                </el-table-column>
                <el-table-column label="Estado" :align="'center'">
                  <template slot-scope="scope">
                    {{ getStatusName(scope.row.statusId) }}
                  </template>
                </el-table-column>
                <el-table-column label="" :align="'center'">
                  <template slot-scope="scope">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="Detalles"
                      placement="top"
                    >
                      <el-button
                        type="primary"
                        icon="el-icon-view"
                        circle
                        @click="goToDetails(scope.row.idBuyOrder)"
                        v-if="user.roles.every((rol) => rol.rolesId != 20)"
                      ></el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </data-tables>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <button class="btn btn-primary" @click="closeOperations">Aceptar</button>
          </span>
        </el-dialog>

        <!-- MODAL USUARIOS ASOCIADOS -->
        <el-dialog
          id="dialogUsuarioAsociado"
          :title="'Usuarios asociados de: ' + company.companyName"
          :visible="showModalAssociatedUsers"
          class="users__modal-mobile"
          :fullscreen="false"
          :lock-scroll="true"
          v-on:close="showModalAssociatedUsers = false"
        >
          <div class="box-body" style="max-height: 100%; overflow: auto">
            <div class="">
              <data-tables
                :data="company.users"
                :pagination-props="{ pageSizes: [5, 10, 15] }"
                :filters="filtersAssociatedUsers"
              >
                <el-table-column
                  v-for="title in titlesAssociatedUsers"
                  :prop="title.prop"
                  :label="title.label"
                  :key="title.prop"
                  sortable="custom"
                >
                </el-table-column>
              </data-tables>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <button class="btn btn-primary" @click="closeAssociatedUsers">Aceptar</button>
          </span>
        </el-dialog>

        <!-- MODAL HISTORIAL DOCUMENTOS -->
        <el-dialog
          :title="'Documentación de ' + company.companyName"
          :visible.sync="showModalDocumentRecord"
          width="40%"
          :lock-scroll="true"
          :before-close="closeDocumentRecord"
        >
          <div class="box-body" style="max-height: 100%; overflow: auto">
            <div class="">
              <data-tables
                :data="company.users"
                :pagination-props="{ pageSizes: [5, 10, 15] }"
                :filters="filtersDocumentRecord"
              >
                <el-table-column
                  v-for="title in titlesAssociatedUsers"
                  :prop="title.prop"
                  :label="title.label"
                  :key="title.prop"
                  sortable="custom"
                >
                </el-table-column>
              </data-tables>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <button class="btn btn-primary" @click="closeDocumentRecord">Aceptar</button>
          </span>
        </el-dialog>

        <!-- FINALIZACION DE MODALES -->

        <div class="box-body">
          <div class="">
            <div style="margin-bottom: 10px">
              <el-row>
                <el-col :span="6">
                  <el-button
                    @click="goToNewProv()"
                    type="primary"
                    icon="el-icon-plus"
                    v-if="user.roles.every((rol) => rol.rolesId != 20)"
                    >Agregar por país</el-button
                  >
                </el-col>
                <el-col :span="6">
                  <div style="margin-right:1%">
                    <countries-group :filter="filters[2]" v-on:update-filter="updateFilter"></countries-group>
                  </div>
                </el-col>
                <el-col :span="12">
                  <el-input
                    v-model.lazy="dummyFilter"
                    @keyup.enter.native="filters[0].value = dummyFilter"
                    @blur="filters[0].value = dummyFilter"
                    @clear="filters[0].value = dummyFilter"
                    placeholder="Buscar"
                    clearable
                  ></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6" v-if="newProvFlags === true" class="flags__container">
                  <router-link v-if="!paramErrorProv" to="/userActivationAR">
                    <el-link :underline="false"><img class="flag" src="static/img/AR_Flag.png"/></el-link>
                  </router-link>
                  <router-link v-if="!paramErrorProv" to="/userActivationPE">
                    <el-link :underline="false"><img class="flag" src="static/img/PE_Flag.png"/></el-link>
                  </router-link>
                </el-col>
              </el-row>
            </div>
            <data-tables-server
              v-loading="loadingProviders"
              :data="providersOrdered"
              @query-change="getProviders"
              :total="totalProviders"
              :pagination-props="{ pageSizes: [10, 20, 30] }"
              :filters="filters"
            >
              <el-table-column
                v-for="title in titles"
                :prop="title.prop"
                :label="title.label"
                :key="title.prop"
                :sortable="title.sortable"
              >
              </el-table-column>
              <el-table-column label="Calificación">
                <template slot-scope="scope">
                  <el-rate
                    disabled
                    v-model.number="scope.row.calification"
                    style="float: left"
                    @change="updateCalification(scope.row, false)"
                  ></el-rate>
                </template>
              </el-table-column>
              <el-table-column label="Rubros" :width="150">
                <template slot-scope="scope">
                  <span v-for="(rubro, index) in scope.row.rubros" :key="rubro.idRubro + index">
                    {{ rubro.nombre }}
                    <span v-if="index + 1 < scope.row.rubros.length"> / </span>
                  </span>
                </template>
              </el-table-column>

              <el-table-column label="" :align="'center'" :width="300">
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Detalles"
                    placement="top"
                    v-if="scope.row.idCompanyStatus === '5'"
                  >
                    <el-button
                      :data-cy="'btn-detalles-'+scope.row.cuit"
                      type="info"
                      icon="fas fa-user"
                      circle
                      @click="showDetails(scope.row)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Detalles"
                    placement="top"
                    v-if="scope.row.idCompanyStatus === '2'"
                  >
                    <el-button
                      :data-cy="'btn-detalles-'+scope.row.cuit"
                      type="warning"
                      icon="fas fa-user"
                      circle
                      @click="showDetails(scope.row)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Usuarios asociados"
                    placement="top-end"
                    v-if="scope.row.idCompanyStatus === '2'"
                  >
                    <el-button
                      :data-cy="'btn-asoc-'+scope.row.cuit"
                      type="primary"
                      icon="el-icon-view"
                      circle
                      @click="getAssociatedUsers(scope.row)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Operaciones"
                    placement="top"
                    v-if="scope.row.idCompanyStatus === '5' && false"
                  >
                    <el-button
                      :data-cy="'btn-oper-'+scope.row.cuit"
                      type="info"
                      icon="el-icon-tickets"
                      circle
                      @click="getOperations(scope.row)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Operaciones"
                    placement="top"
                    v-if="scope.row.idCompanyStatus === '2' && false"
                  >
                    <el-button
                      :data-cy="'btn-asoc-'+scope.row.cuit"
                      type="primary"
                      icon="el-icon-tickets"
                      circle
                      @click="getOperations(scope.row)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Documentación"
                    placement="top"
                    v-if="scope.row.idCompanyStatus === '5' && false"
                  >
                    <el-button
                      :data-cy="'btn-doc-'+scope.row.cuit"
                      type="info"
                      icon="el-icon-document"
                      circle
                      @click="getDocumentation(scope.row)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Documentación"
                    placement="top"
                    v-if="scope.row.idCompanyStatus === '2' && false"
                  >
                    <el-button
                      :data-cy="'btn-doc-'+scope.row.cuit"
                      type="success"
                      icon="el-icon-document"
                      circle
                      @click="getDocumentation(scope.row)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Activar"
                    placement="top"
                    v-if="scope.row.idCompanyStatus === '5'"
                  >
                    <el-button
                      :data-cy="'btn-start-'+scope.row.cuit"
                      type="success"
                      icon="el-icon-right"
                      circle
                      @click="startCompany(scope.row)"
                      v-if="user.roles.every((rol) => rol.rolesId != 20)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Suspender"
                    placement="top"
                    v-if="scope.row.idCompanyStatus === '2'"
                  >
                    <el-button
                      :data-cy="'btn-stop-'+scope.row.cuit"
                      type="danger"
                      icon="el-icon-switch-button"
                      circle
                      @click="stopCompany(scope.row)"
                      v-if="user.roles.length > 0 && user.roles.every((rol) => rol.rolesId != 20)"
                    ></el-button>
                  </el-tooltip>

                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Comentario"
                    placement="top"
                  >
                    <el-button
                      :data-cy="'btn-comment-'+scope.row.cuit"
                      type="info"
                      icon="fa fa-comment"
                      circle
                      @click="commentCompany(scope.row)"
                    ></el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </data-tables-server>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
require('moment')
import datepicker from 'vue-date-picker'
import Vue from 'vue'
import api from '../../api'
import ElementUI, { ButtonGroup } from 'element-ui'
import DataTables from 'vue-data-tables'
import 'element-ui/lib/theme-chalk/index.css'
import lang from 'element-ui/lib/locale/lang/es'
import locale from 'element-ui/lib/locale'
import { mapState } from 'vuex'

import apiHelper from '../helpers/apiHelper'

Vue.use(ElementUI)
locale.use(lang)
Vue.use(DataTables)

export default {
  name: 'Settings',
  components: {
    datepicker,
    'countries-group': ButtonGroup
  },
  data (router) {
    return {
      previousDocuments: [],
      newProvFlags: false,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      section: 'AllComments',
      loading: '',
      showModal: false,
      showModalComment: false,
      showModalDocumentation: false,
      showModalOperations: false,
      showModalDetails: false,
      showModalAssociatedUsers: false,
      showModalDocumentRecord: false,
      currentCompany: [],
      currentIdRubro: [],
      company: '',
      documents: [],
      filteredDocuments: [],
      filteredDocumentsRecord: [],
      rubros: [],
      selectedRow: null,
      comment: null,
      companyNew: {
        nombre: '',
        razonSocial: '',
        // 'corporateMail': '',
        cuit: '',
        idCompanyStatus: '',
        descripcion: ''
      },
      titles: [
        {
          // Columnas que se van a mostrar
          prop: 'company',
          label: 'Compañía',
          align: 'center',
          sortable: 'custom'
        },
        {
          prop: 'fiscalId',
          label: 'Identificación Fiscal',
          align: 'center',
          sortable: 'custom'
        },
        {
          prop: 'idType',
          label: 'Tipo de Identificación',
          align: 'center',
          sortable: 'custom'
        },
        {
          prop: 'status',
          label: 'Estado',
          align: 'center'
        }
        /* {
          prop: 'corporateMail',
          label: 'Mail corporativo',
          align: 'center'
        } */
      ],
      filters: [
        {
          prop: ['companyName', 'fiscalId', 'company'],
          value: ''
        }
      ],
      titlesOperations: [
        {
          // Columnas que se van a mostrar
          prop: 'nic',
          label: 'OC'
        },
        {
          prop: 'fecha_liberacion',
          label: 'Liberación'
        }
      ],
      titlesAssociatedUsers: [
        {
          // Columnas que se van a mostrar
          prop: 'name',
          label: 'Usuarios Asociados'
        }
      ],
      titlesDocumentRecord: [
        {
          prop: 'document_record',
          label: 'Historial de documentos'
        }
      ],
      filtersOperations: [
        {
          prop: ['nic'],
          value: ''
        },
        {
          filterFn: (row, filter) => {
            return Object.keys(row).some((prop) => {
              if (prop === 'fecha_liberacion') {
                if (filter.value !== null) {
                  return (
                    new Date(row.fecha_liberacion).getTime() <=
                      filter.value[1].getTime() &&
                    new Date(row.fecha_liberacion).getTime() >= filter.value[0].getTime()
                  )
                } else {
                  return true
                }
              }
            })
          },
          prop: ['fecha_liberacion'],
          value: ''
        },
        {
          prop: 'statusId',
          value: ''
        }
      ],
      filtersAssociatedUsers: [
        {
          prop: ['name'],
          value: ''
        }
      ],
      filtersDocumentRecord: [
        {
          prop: ['document_record'],
          value: ''
        }
      ],
      totalProviders: 0,
      providers: [],
      loadingProviders: false,
      currentApiCalls: 0,
      dummyFilter: ''
    }
  },
  computed: {
    ...mapState(['user']),
    datetime () {
      return new Date()
    },
    providersOrdered () {
      return this.providers.slice().sort((a, b) => a.status - b.status)
    },
    statusList () {
      return this.$store.state.countStatus
    }
  },
  methods: {
    viewCompanyData (step, idCompany, country) {
      this.$router.push('/companyData/' + idCompany + '/' + step + '/' + country)
    },
    goToNewProv (idCompany) {
      this.newProvFlags = !this.newProvFlags
    },
    startLoading () {
      this.currentApiCalls++
      this.loadingProviders = true
    },
    stopLoading () {
      this.currentApiCalls--
      if (this.currentApiCalls === 0) this.loadingProviders = false
    },
    getTotalProvider (queryInfo = '') {
      let substringPosition = queryInfo.search('condition=')
      let query = queryInfo.substring(substringPosition + 10)
      query = '(idCompanyStatus=2%20)'
      apiHelper.getTotal('companyCountriesStatus', query).then((count) => {
        this.totalProviders = count
      })
    },
    getProviders (queryInfo = '') {
      // We need to pass the component's this context
      // to properly make use of http in the auth service
      let query = apiHelper.getQueryForApi(queryInfo)
      this.startLoading()
      this.getTotalProvider(query)
      api
        .request('GET', `api/listProviders` + query)
        .then((response) => {
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.error) {
            return
          }
          if (data) {
            console.log(data)
            let provs = data.filter(
              (prov) => prov.idCompanyStatus === '2' || prov.idCompanyStatus === '5'
            )
            provs.forEach((el, index) => {
              el.calification = parseInt(el.calification)
            })
            this.providers = provs
          }
          this.stopLoading()
        })
        .catch((error) => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
          this.loadingProviders = false
        })
    },
    goToDetails (idBuyOrder) {
      this.$router.push('/invoicedetail?i=' + idBuyOrder)
    },

    getStatusName (statusId) {
      return this.statusList.find((el) => el.statusId === statusId).description
    },
    showModalCreateProvider () {
      this.showModal = true
      this.currentIdRubro = []
    },
    showDetails (row) {
      this.currentCompany = row
      this.currentIdRubro = []
      if (this.currentCompany.rubros !== undefined) {
        this.currentCompany.rubros.forEach((item, index) => {
          this.currentIdRubro[index] = item.idRubro
        })
      }
      this.showModalDetails = true
    },
    showDetailsTEST (row) {
      // this.showModalDetails = true
    },
    getOperations (row) {
      api
        .request('GET', 'api/companyOperations/' + row.idCompany)
        .then((response) => {
          this.showModalOperations = true
          this.company = row
          this.company.operations = response.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    /*
      canDeleteProvider (idCompany) {
        api.request('GET', 'api/canDeleteCompany/' + idCompany)
        .then(response => {
          let patata = response.data
          return patata
        })
      },
      */

    getDocumentation (row) {
      this.currentCompany = row
      this.company = row
      api.request('GET', 'api/generic/document').then((response) => {
        this.documents = response.data
        this.documents.forEach((doc) => {
          if (
            this.company.documents.find((el) => el.idDocument === doc.idDocument) ===
            undefined
          ) {
            this.company.documents.push({
              idDocument: doc.idDocument,
              documentName: doc.documentName,
              idProvider: this.company.idCompany,
              status: '0'
            })
          }
        })
        // console.log(this.currentCompany.documents)
        this.documents.forEach((document, index) => {
          this.filteredDocuments[index] = this.currentCompany.documents.find(
            (el) =>
              el.idProviderDocumentStatus === '2' && el.idDocument === String(index + 1)
          )
        })
        this.getDocumentRecord()
        this.showModalDocumentation = true
      })
    },
    getAssociatedUsers (row) {
      api
        .request('GET', 'api/AssociatedUsers/' + row.idCompany)
        .then((response) => {
          this.showModalAssociatedUsers = true
          this.company = row
          this.company.users = response.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    saveCompany () {
      if (
        this.companyNew.nombre !== '' &&
        this.companyNew.razonSocial !== '' /* && this.companyNew.corporateMail */ &&
        this.companyNew.cuit !== '' &&
        this.currentIdRubro !== undefined &&
        this.currentIdRubro.length > 0
      ) {
        api
          .request(
            'POST',
            'api/generic/company',
            JSON.stringify({
              company: this.companyNew.nombre,
              companyName: this.companyNew.razonSocial,
              idCompanyStatus: 2,
              cuit: this.companyNew
                .cuit /*, 'corporateMail': this.companyNew.corporateMail */,
              reasonCalification: this.companyNew.descripcion,
              idCompany: ''
            })
          )
          .then((response) => {
            this.currentIdRubro.forEach((item, index) => {
              api
                .request(
                  'POST',
                  'api/generic/rubrosCompany/',
                  JSON.stringify({
                    idRubro: this.currentIdRubro[index],
                    idCompany: response.data.idCompany
                  })
                )
                .then((response) => {
                  this.$message.success('Se ha agregado la nueva empresa', 'success')
                  this.hideModal()
                  this.$parent.getProviders()
                })
            })
          })
          .catch((error) => {
            this.$message.error(error.response.data, 'error')
          })
      } else {
        this.$message.warning('Debe completar todos los campos', 'warning')
      }
    },
    openNodeUrl (node, prop, treeNode) {
      if (!node.children) {
        let win = window.open(node.url, '_blank')
        win.focus()
      }
    },
    getDocumentRecord () {
      // this.previousDocuments.children.push(this.currentCompany.documents)
      // console.log(this.currentCompany.documents.find(el => el.idProviderDocumentStatus === '2'))

      // this.currentCompany.documents.forEach((documents, index) => {
      // this.company.documents.push({'idDocument': doc.idDocument, 'documentName': doc.documentName, 'idProvider': this.company.idCompany, 'status': '0'})
      // console.log(this.currentCompany.documents[index])
      // if (typeof this.currentCompany.documents[index]['emisionDate'] !== 'undefined') {
      // (((this.documents))) serian los 6 tipos de documentos
      console.log(this.previousDocuments)
      this.documents.forEach((document, index2) => {
        this.previousDocuments[index2] = [
          { label: 'Documentos anteriores', children: [] }
        ]
        this.previousDocuments[index2][0].children = this.currentCompany.documents.filter(
          (el) =>
            el.idProviderDocumentStatus === '2' &&
            el.idDocument === String(document.idDocument)
        )
        if (
          this.previousDocuments[index2][0].children.length === 0 ||
          this.previousDocuments[index2][0] === undefined
        ) {
          delete this.previousDocuments[index2]
        } else {
          this.previousDocuments[index2][0].children.forEach((docChildren) => {
            docChildren.label = docChildren.emisionDate
          })
        }
      })
      // -const newChild = { id: index, label: this.currentCompany.documents[index]['idProviderDocument'], children: [] }
      // const finalData = JSON.parse(JSON.stringify(newChild))
      // -this.previousDocuments[0].children.push(newChild)
      // this.currentCompany.documents[index] = this.currentCompany.documents.find(el => el.idProviderDocumentStatus === '2' && el.idDocument === String(index + 1))
      // this.previousDocuments.children.push([index])
      // console.log(this.currentCompany.documents[index])

      // this.previousDocuments = this.previousDocuments.filter(el => el !== undefined)
      // console.log(this.documents)
      // }
      // })
    },
    updateCompany () {
      if (
        this.currentCompany.company !== '' &&
        this.currentCompany.companyName !== '' &&
        this.currentCompany.cuit !== '' &&
        this.currentIdRubro !== undefined &&
        this.currentIdRubro.length > 0
      ) {
        api
          .request(
            'POST',
            'api/generic/company/' + this.currentCompany.idCompany,
            JSON.stringify({
              company: this.currentCompany.company,
              companyName: this.currentCompany.companyName,
              cuit: this.currentCompany.cuit,
              address: this.currentCompany.address,
              billingAddress: this.currentCompany.billingAddress,
              comments: this.currentCompany.comments,
              reasonCalification: this.currentCompany.reasonCalification
            })
          )
          .then((response) => {
            api
              .request(
                'GET',
                'api/deleteRubrosFromCompany/' + this.currentCompany.idCompany
              )
              .then((response) => {
                this.currentIdRubro.forEach((item, index) => {
                  api
                    .request(
                      'POST',
                      'api/generic/rubrosCompany/',
                      JSON.stringify({
                        idRubro: this.currentIdRubro[index],
                        idCompany: this.currentCompany.idCompany
                      })
                    )
                    .then((response) => {})
                })
                this.$message.success(
                  'Se ha actualizado la empresa correctamente',
                  'success'
                )
                this.showModalDetails = false
                this.$parent.getProviders()
              })
          })
      } else {
        this.$message.warning('Debe completar todos los campos', 'warning')
      }
    },
    saveDocumentation () {
      let string = ''
      this.company.documents.forEach((el) => {
        string += this.company.idCompany + 'o' + el.idDocument + 'o' + el.status + '_'
      })
      string = string.slice(0, -1)
      api
        .request(
          'GET',
          'api/updateDocumentation/' + this.company.idCompany + '/' + string
        )
        .then((response) => {
          this.closeDocumentation()
        })
    },
    closeDocumentation () {
      this.showModalDocumentation = false
      this.$parent.getProviders()
    },
    closeOperations () {
      this.showModalOperations = false
    },
    closeAssociatedUsers () {
      this.showModalAssociatedUsers = false
    },
    closeDocumentRecord () {
      this.showModalDocumentRecord = false
    },
    toggleCalification (row) {
      if (this.selectedRow === row.idCompany) {
        this.selectedRow = null
      } else {
        this.selectedRow = row.idCompany
      }
    },
    hideModal () {
      this.showModal = false
      this.currentIdRubro = []
    },
    hideModalComment () {
      this.showModalComment = false
    },
    updateCalification (row, isModal) {
      let comment = ''
      if (row.reasonCalification.trim() === '' || row.reasonCalification === null) {
        if (isModal === 'true') {
          this.$message({
            type: 'warning',
            message: 'Descripción es Requerido'
          })
        } else {
          comment = '_'
        }
      } else {
        // reemplazo los saltos de linea por _ para luego en el updateCAlification de company volver a reemplazarlos por saltos de linea
        // ya que aquí no los toma
        comment = row.reasonCalification.trim().replace(/\s+/g, '-')
        comment = comment.trim().replace(/[\n\r]+/g, '_')
        console.log('row', row)
        console.log('comment', comment)
        this.showModalComment = false
      }

      api
        .request(
          'POST',
          'api/updateCalification/Company/' +
            row.idCompany +
            '/' +
            row.calification +
            '/' +
            comment
        )
        .then((response) => {
          this.$parent.getProviders()
        })
        .catch((error) => {
          this.$store.commit('TOGGLE_LOADING')
          this.$parent.getProviders()
          console.log(error)
        })
    },
    commentCompany (row) {
      this.company = row
      this.showModalComment = true
    },
    stopCompany (row) {
      this.$confirm('¿Realmente desea suspender la compañía?', 'Advertencia', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false
      }).then(() => {
        api
          .request('GET', 'api/updateStopCompanyStatus/' + row.idCompany)
          .then((response) => {
            this.$parent.getProviders()
          })
      })
    },
    startCompany (row) {
      this.$confirm('¿Desea Activar la compañía?', 'Advertencia', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false
      }).then(() => {
        api
          .request('GET', 'api/updateStartCompanyStatus/' + row.idCompany)
          .then((response) => {
            this.getProviders()
          })
      })
    },
    deleteCompany (row) {
      this.$confirm('¿Está seguro que desea eliminar esta Empresa?', 'Atención', {
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        api.request('GET', 'api/canDeleteCompany/' + row.idCompany).then((response) => {
          if (response.data) {
            api
              .request('POST', 'api/delete/company/' + row.idCompany)
              .then((response) => {
                this.$parent.getProviders()
                this.$message({
                  type: 'success',
                  message: 'Se ha eliminado la Empresa'
                })
              })
              .catch((error) => {
                console.log(error)
                this.$message({
                  type: 'danger',
                  message: 'Error al eliminar el Empresa'
                })
              })
          } else {
            this.$message({
              type: 'warning',
              message:
                'La empresa contiene información asociada, no es posible eliminarla'
            })
          }
        })
      })
    },
    getRubros () {
      api
        .request('GET', 'api/generic/rubros')
        .then((response) => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            this.rubros = data
          }
        })
        .catch((error) => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    },
    updateFilter (updatedFilter) {
      const index = this.filters.findIndex(f => f.prop === updatedFilter.prop)
      this.filters[index].value = updatedFilter.value
    }
  },
  beforeMount () {
    this.getRubros()
  }
}
</script>

<style>
@media screen and (max-width: 992px) {
  .users__modal-mobile .el-dialog{
    width:80%;
    margin-top:-400px;
  }

  .users__modal-mobile {
  }
}

.datetime-picker input {
  height: 4em !important;
}

.flags__container {
  margin-top: 10px;
}

.flag {
  width: 60px;
  margin-right: 10px;
  border-radius: 3px;
}

.flag:hover {
  border-radius: 3px;
  border: 3px solid #347cc4;
}

.calification-reason {
  margin-top: 20px;
  border-radius: 5px;
  background-color: #eee;
}

.height-enter-active {
  transition: all 0.4s ease-in-out;
}

.height-enter,
.height-leave-to {
  transform: scaleY(0);
}

.el-dialog_wrapper,
.el-dialog {
  overflow: hidden !important;
}

.el-dialog .el-table {
  height: calc(100vh - 278.87px);
  overflow: auto !important;
}

.input-label {
  display: inline-block;
  padding: 2px 10px;
}
</style>



// WEBPACK FOOTER //
// AllProviders.vue?33bf590c